import { combineReducers } from 'redux';
import tds from './tools/tds';
import topflop from './tools/topflop';
import dlpicture from './tools/dlpicture';

export default combineReducers({
    tds,
    topflop,
    dlpicture
});



// WEBPACK FOOTER //
// ./src/reducers/app/tools.js